import { lazy } from 'react';
/** Открывает форму прайс-листа */
export const PriceListFormPageAsync = lazy(() => import('./PriceListForm/PriceListFormPage'));